import React from 'react';
import { useTranslation } from 'react-i18next';

const FamilyBuildingGoals = ({ nextStep, prevStep, handleChange, formData, error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  // Store only translated values
  const goalList = [
    t('pregnent'),
    t('sperem'),
    t('adopt'),
    t('purse'),
    t('explore')
  ];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const updatedGoals = checked
      ? [...formData.familyGoals, value]
      : formData.familyGoals.filter((goal) => goal !== value);

    handleChange({ target: { name: 'familyGoals', value: updatedGoals } });
  };

  return (
    <div>
      <h3 className="page-heading-secondary-black-500 mb-5">{t('buildinggoals')}</h3>
    <p>Choose all that apply</p>
      {goalList.map((label, index) => (
        <div key={index} className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="checkbox"
            className="form-check-input radio-btn win-form-check-input"
            value={label}
            checked={formData.familyGoals.includes(label)}
            onChange={handleCheckboxChange}
          />
          <label className="multistep-form-radio-checkbox-label">{label}</label>
        </div>
      ))}

      {error && <p className="text-danger">{error}</p>}

      <div className="mt-5">
      {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={nextStep}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>{t('back')}</button>
            <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FamilyBuildingGoals;
